import Select from 'react-select'
import {useTranslation} from 'react-i18next'

const CustomSelect = ({
  onChange,
  options,
  value,
  defaultValues,
  className,
  isLoading,
  isLoadTrueFalse,
  placeholderText,
  isMulti,
  isDisabled,
}: any) => {
  const {t} = useTranslation()

  const defaultValue = (options: any, value: any) => {
    if (!Array.isArray(options)) return ''

    return options.find((option: any) => option.id === value || option.name === value) || ''
  }

  return (
    <div className={className}>
      <Select
        styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
        menuPortalTarget={document.body}
        key={options}
        placeholder={t('VALIDATION.SELECT_', {name: placeholderText})}
        value={isMulti ? value : defaultValue(options, value)}
        defaultValue={defaultValues}
        onChange={(value) => {
          onChange(value ? value : '')
        }}
        options={options}
        getOptionLabel={(options: any) => options.name}
        getOptionValue={(options: any) => options.id}
        backspaceRemovesValue={true}
        isLoading={isLoadTrueFalse ? isLoading : false}
        isClearable={true}
        isSearchable={true}
        isMulti={isMulti}
        isDisabled={isDisabled}
      />
    </div>
  )
}

export default CustomSelect
